import Vue from 'vue';
import Router from 'vue-router';
import AuctionCreateForm from './views/AuctionCreateForm.vue';
import AuctionList from './views/AuctionList.vue';
import AuctionDetail from './views/AuctionDetail.vue';
import Login from './views/Login.vue';
import UserRegistration from './views/UserRegistration.vue';
import AuctionEdit from './views/AuctionUpdateForm.vue';
import ContactUs from './views/ContactUs.vue';
import Profile from './views/Profile.vue';
import ResetPassword from './views/ResetPassword.vue';
import store from './store';

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/auctions/create',
      name: 'auctionCreate',
      component: AuctionCreateForm,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/auctions',
      name: 'auctionList',
      component: AuctionList,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/auctions/:id',
      name: 'auctionDetail',
      component: AuctionDetail,
      props: true,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/auctions/:id/edit',
      name: 'auctionEdit',
      component: AuctionEdit,
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: '',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/registration',
      name: 'registration',
      component: UserRegistration,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: ContactUs,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/reset_password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        requiresAuth: false,
      },
      props: true,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.loginInfo.isLogged) {
      next({ name: 'login' });
    } else {
      next(); // go to wherever I'm going
    }
  } else {
    next(); // does not require auth, make sure to always call next()!
  }
});

export default router;
